import { heIL as coreHeIL } from "@mui/material/locale";
import {
  createTheme,
  ThemeProvider as ThemeProviderMui,
} from "@mui/material/styles";
import { heIL as calendarHeIL } from "@mui/x-date-pickers/locales";
import { ReactElement, useMemo } from "react";
import { RouterProvider } from "react-router-dom";
import { StyleSheetManager } from "styled-components";
import { Middleware } from "stylis";
import stylisRTLPlugin from "stylis-plugin-rtl";

import {
  DocumentTitle,
  LocalizationProvider,
  SessionGateLoader,
} from "@ryde/controls";
import { GlobalAppContextProvider, useRtl } from "@ryde/redux";
import { Log, shouldDebugForms } from "@ryde/shared";
import { AppGlobalStyles, themeMuiDefault } from "@ryde/theme";

import { AuthInitWrapper } from "../wrappers/auth-init.wrapper";
import { appRouter } from "./app.routes";

export const App = (): ReactElement => {
  const { isRtl, direction } = useRtl();

  const muiTheme = useMemo(() => {
    const curTheme = createTheme(
      {
        ...themeMuiDefault,
        direction,
      },
      isRtl ? calendarHeIL : {},
      isRtl ? coreHeIL : {},
    );
    return curTheme;
  }, [direction, isRtl]);

  const stylusPlugins = useMemo(() => {
    const plugins = isRtl ? [stylisRTLPlugin] : [];
    return plugins;
  }, [isRtl]);

  if (shouldDebugForms()) {
    Log.warn("react-hook-forms set in debug mode");
  }

  return (
    <ThemeProviderMui theme={muiTheme}>
      <AppGlobalStyles $isRtl={isRtl} />
      <StyleSheetManager
        stylisPlugins={stylusPlugins as unknown as Middleware[]}
      >
        <LocalizationProvider>
          <GlobalAppContextProvider>
            <DocumentTitle />
            <AuthInitWrapper>
              <RouterProvider router={appRouter()} />
            </AuthInitWrapper>
            <SessionGateLoader />
          </GlobalAppContextProvider>
        </LocalizationProvider>
      </StyleSheetManager>
    </ThemeProviderMui>
  );
};
